import { render, staticRenderFns } from "./editable-html.vue?vue&type=template&id=4e725c54&scoped=true"
import script from "./editable-html.vue?vue&type=script&lang=ts"
export * from "./editable-html.vue?vue&type=script&lang=ts"
import style0 from "./editable-html.vue?vue&type=style&index=0&id=4e725c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e725c54",
  null
  
)

export default component.exports